import { memo } from 'react';
import { Check } from 'lucide-react';
import { billedLabel, formatMoney, intervalSuffix, priceFor, OUTLINE_PLAN_BTN, PRIMARY_PLAN_BTN } from './helper';

const PlanCard = ({
  plan, household, interval, onChoose,
  disabled = false, cta = null, current = false,
  // When the move won't take effect today, say so on the card itself — reading
  // it only in the confirmation is too late to compare the options.
  note = null
}) => {
  const { name, description, benefits = [], most_popular } = plan || {};

  return (
    <div
      className={`relative flex flex-col rounded-2xl border-2 bg-white p-5 transition-all duration-200 ${most_popular
        ? 'border-teamcare-blue shadow-md'
        : 'border-secondary-200 hover:border-secondary-300'
        }`}
    >
      {most_popular && (
        <span className="absolute -top-3 left-5 rounded-full border border-teamcare-blue bg-blue-50 px-3 py-0.5 text-[10px] font-bold uppercase tracking-wider text-teamcare-blue">
          Most popular
        </span>
      )}

      <p className="text-[10px] font-semibold uppercase tracking-widest text-secondary-400">{name}</p>

      <p className="mt-1 flex items-baseline gap-1.5">
        <span className="text-3xl font-extrabold text-secondary-900">
          {formatMoney(priceFor(plan, household, interval))}
        </span>
        <span className="text-sm font-medium text-secondary-400">{intervalSuffix(interval)}</span>
      </p>

      <p className="mt-0.5 text-xs text-secondary-400">{billedLabel(interval)}</p>

      {description && <p className="mt-3 text-xs leading-relaxed text-secondary-500">{description}</p>}

      {/* benefits arrive pre-ordered, with the discount line already written out */}
      <ul className="mt-4 flex-1 space-y-2.5">
        {benefits.map(({ label, emphasis }, index) => (
          <li key={`${name}-benefit-${index}`} className="flex items-start gap-2">
            <Check
              size={15}
              strokeWidth={3}
              className={`mt-0.5 shrink-0 ${emphasis ? 'text-teamcare-blue' : 'text-success-500'}`}
            />
            <span className={`text-[13px] ${emphasis ? 'font-bold text-secondary-900' : 'text-secondary-700'}`}>
              {label}
            </span>
          </li>
        ))}
      </ul>

      <button
        type="button"
        disabled={disabled || current}
        onClick={() => onChoose(plan)}
        className={`mt-5 w-full disabled:opacity-60 ${most_popular && !current ? PRIMARY_PLAN_BTN : OUTLINE_PLAN_BTN}`}
      >
        {current ? 'Your current plan' : cta || `Choose ${name}`}
      </button>

      {note && !current && (
        <p className="mt-2 text-center text-[11px] font-medium text-secondary-400">{note}</p>
      )}
    </div>
  );
};

export default memo(PlanCard);
